import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Loading, LoadingController } from 'ionic-angular';
/*
  Generated class for the LoadingServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LoadingServiceProvider {

  loading: Loading;
  constructor(public http: HttpClient,
    public loadingCtrl: LoadingController
  ) {

  }

  presentLoadingDefault(enableBackDrop: boolean = false) {
    this.loading = this.loadingCtrl.create({
      enableBackdropDismiss: enableBackDrop
    });

    return this.loading.present();
  }

  dismissLoading() {
    if (this.loading != undefined) {
      return this.loading.dismissAll();
    }

    return false;
  }

  loader() {
    return this.loadingCtrl.create();
  }

}



// WEBPACK FOOTER //
// ./src/providers/loading-service/loading-service.ts